var __TEMP__ = require('./_arrayReduce.js');var arrayReduce = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./deburr.js');var deburr = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./words.js');var words = __REQUIRE_DEFAULT__(__TEMP__);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = createCompounder;
